import { graphql } from "@cappelendamm/crystallize-types/core/gql";
import Logger from "@cappelendamm/logger";
export const CancelSubscriptionContractMutation = graphql(`
  mutation CancelSubscriptionContract(
    $subscriptionContractId: ID!
    $input: CancelSubscriptionContractInput!
  ) {
    cancelSubscriptionContract(
      subscriptionContractId: $subscriptionContractId
      input: $input
    ) {
      __typename
      ... on SubscriptionContractAggregate {
        id
      }
      ... on ExperimentalFeaturesNotAvailableError {
        errorName
        message
      }
      ... on UnauthorizedError {
        errorName
        message
      }
      ... on UnknownError {
        errorName
        message
      }
    }
  }
`);
export const cancelSubscriptionContract = async ({ id }, { client }) => {
    Logger.log("Cancelling subscription contract in Crystallize: ", id);
    const data = await client.core.request(CancelSubscriptionContractMutation, {
        subscriptionContractId: id,
        input: { deactivate: false },
    });
    if (data.cancelSubscriptionContract.__typename ===
        "SubscriptionContractAggregate") {
        return data.cancelSubscriptionContract.id;
    }
    throw new Error(`Error cancelling subscription contract: ${id}. ErrorName: ${data.cancelSubscriptionContract.errorName}. Message: ${data.cancelSubscriptionContract.message}`);
};
